//@ts-ignore
import React from 'react';
import { CSSProperties } from 'react';
import classNames from 'classnames';
import { Props } from './types';

export const Frame = ({
  iframeUrl,
  elementId = 'showcase',
  className = null,
  style = {},
  allowIframePolicy = 'geolocation;fullscreen;vr;autoplay;xr-spatial-tracking',
  handleRef = () => {},
}: Props) => {
  return (
    <iframe
      id={elementId}
      style={style as CSSProperties}
      className={classNames('showcase', className)}
      frameBorder={0}
      allow={allowIframePolicy}
      src={iframeUrl}
      ref={handleRef}
    />
  );
};
